export default __webpack_public_path__ + "static/media/T_64_mobile.5d5dee48.jpg";